import React from 'react';
import { formatMessage } from 'devextreme/localization';
import styles from '../datagridmvp.module.scss';

function renderSumName(value, seq) {
  if (seq === 'nett') {
    switch (value) {
      case 'nett' :
      case 'virtualNetto' :
        return formatMessage('textDataGrid').nett;
      case 'capacityPipe' :
        return formatMessage('textDataGrid').capacityPipe;
      case 'readyWeightForSumNetto' :
        return formatMessage('textTableProduction').readyWeightNetto;
      default :
        return formatMessage('textDataGrid').quantity;
    }
  } else if (seq === 'gross') {
    switch (value) {
      case 'gross' :
      case 'virtualBrutto' :
        return formatMessage('textDataGrid').gross;
      case 'capacityPipe' :
        return formatMessage('textDataGrid').capacityPipe;
      case 'readyWeightForSumOff' :
        return formatMessage('textTableProduction').readyWeightOff;
      default :
        return formatMessage('textDataGrid').quantityRemain;
    }
  }
  return '';
}

const CustomFooter = ({
  outerDataForFooter,
  visibleSummary,
  footerSumCount,
  footerSelectedColumnData,
  footerSumSelectedColumn,
  altWeightNettoField,
  altWeightBruttoField,
  showSumCount,
  showSumNetto,
  showSumBrutto,
  footerSumSumNetto,
  footerSumSumBrutto,
  units,
  additionalFooterData
}) => {
  if (outerDataForFooter) {
    return (
      <div className={styles.footer}>
        <div className={'footer-left'}>{`${formatMessage('textDataGrid').alreadySelected}: ${footerSumCount.toFixed(2)} ${formatMessage('textDataGrid').tonne}`}</div>
        <div className={'footer-right'}>
          {`${formatMessage('textDataGrid').availableForBinding}: ${(outerDataForFooter - footerSumCount).toFixed(2)} ${formatMessage('textDataGrid').tonne}`}
        </div>
      </div>
    );
  }
  if (visibleSummary) {
    return (
      <div className={styles.footer}>
        <div className={'footer-left'}>{showSumCount ? `${formatMessage('textDataGrid').pieceQU}: ${footerSumCount}` : ''}</div>
        <div className={'footer-right'}>
          {footerSelectedColumnData.caption && `${footerSelectedColumnData.caption} ${formatMessage('textDataGrid').selectedSum}: ${footerSumSelectedColumn} `}
          {`${formatMessage('textDataGrid').textTotal}: 
            ${showSumNetto ? `${renderSumName(altWeightNettoField, 'nett')} – 
                ${footerSumSumNetto.toFixed(3).replace(new RegExp('\\.', 'g'), ',')} 
                ${(units === 'tonne') ? formatMessage('textDataGrid').tonne : units}` : ''}
            ${showSumNetto && showSumBrutto ? ', ' : ''}
            ${showSumBrutto ? `${renderSumName(altWeightBruttoField, 'gross')} – 
                ${footerSumSumBrutto.toFixed(3).replace(new RegExp('\\.', 'g'), ',')} 
                ${(units === 'tonne') ? formatMessage('textDataGrid').tonne : units}` : ''}`}
          {additionalFooterData && ', '}
          {additionalFooterData}
        </div>
      </div>
    );
  }

  return <></>;
};

export default React.memo(CustomFooter);
